<template>
    <div class="about" style="font-size: 14px;">
        <hs-header></hs-header>
        <h2>{{detailInfo.name}}</h2>
        <div class="right">
            <div class="card">
                <div class="item">
                    <label>编号：</label>
                    <span>{{detailInfo.id}}</span>
                </div>
                <div class="item">
                    <label>战术：</label>
                    <span>{{detailInfo.tacticName}}</span>
                </div>
                <div class="item" v-if="detailInfo.platformShow">
                    <label>平台：</label>
                    <span>{{detailInfo.platformShow}}</span>
                </div>
                <div class="item" v-if="detailInfo.permissionRequiredShow">
                    <label>权限：</label>
                    <span>{{detailInfo.permissionRequiredShow}}</span>
                </div>
                <div class="item" v-if="detailInfo.dataSourcesShow">
                    <label>数据来源：</label>
                    <span>{{detailInfo.dataSourcesShow}}</span>
                </div>
            </div>
        </div>
        <div class="left" :class="detailInfo.id"></div>
        <div class="mitigations" v-if="detailInfo.relations.mitigations">
            <h2>缓解措施建议</h2>
            <table style="border-collapse: collapse;">
                <thead>
                <tr>
                    <th>缓解措施</th>
                    <th>描述</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="d in detailInfo.relations.mitigations">
                    <td style="white-space: nowrap">{{d.name}}</td>
                    <td v-html="d.description"></td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="detection" v-if="detailInfo.relations.detection">
            <h2>检测建议</h2>
            <p v-html="detailInfo.relations.detection"></p>
        </div>
    </div>
</template>
<style>
    label {
        font-weight: 600;
    }

    .right {
        margin-left: 12px;
    }

    .card {
        padding: 8px;
    }
    .about {
        padding: 16px 18px 12px 18px;
    }
    table {
        border-color: #dfdfdf;
        empty-cells: hide;
    }
    th, td {
        border: 1px solid #dee2e6;
        padding: 7px;
    }
</style>
<script>
  import Axios from 'axios';
  import $ from 'jquery';

  export default {
    data() {
      return {
        detailInfo: {
          description: null,
          name: '',
          id: '',
          details: {},
          dataSourcesShow: '',
          platformShow: '',
          permissionRequiredShow: '',
          relations: {
            mitagations: []
          },
          mitigationShow: [],
          tacticName: ''
        }
      }
    },
    watch: {
      $route() {
        this.getDetail()
      }
    },
    created() {
      this.getDetail()
    },
    methods: {
      getDetail() {
        //const metas = await Promise.all([Axios.get('/js/technique_metadata.json'), Axios.get('/js/tactic_metadata.json')])
        /*this.detailInfo = this.$route.params.techniqueMeta.data.filter(d => d.id === this.$route.params.id)[0];
        this.detailInfo.tacticName = this.$route.params.tacticMeta.data.filter(d => d.id === this.$route.params.tacticId)[0].name;*/
        if(window.localStorage.getItem('tacticName')) {
          this.detailInfo = JSON.parse(window.localStorage.getItem('detailInfo'));
          this.detailInfo.tacticName = window.localStorage.getItem('tacticName');
          this.detailInfo.platformShow = this.detailInfo.details.platform ? this.detailInfo.details.platform.join('，') : '';
          this.detailInfo.permissionRequiredShow = this.detailInfo.details.permissionRequired ? this.detailInfo.details.permissionRequired.join('，') : '';
          this.detailInfo.dataSourcesShow = this.detailInfo.details.platform ? this.detailInfo.details.dataSources.join('，') : '';
          this.detailInfo.mitigationShow = this.detailInfo.relations.mitigations;
          window.setTimeout(() => {
            $(`.${this.detailInfo.id}`).html(this.detailInfo.description);
          })
        } else {
          this.$router.push({name: 'home'});
        }
      }
    }
  }
</script>
